.page {
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--page-pad-y) var(--page-pad-x) clamp(40px, 5vw, 80px);
  background: #fff;
  container-type: inline-size;
  container-name: checkout;
}

.head {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 18px;
}

.title {
  font-family: var(--font-display);
  font-size: var(--fs-2xl);
  font-weight: 800;
  letter-spacing: 0.04em;
  margin: 0;
}

.muted { color: var(--color-ink-soft); }

.link { color: var(--color-ember-dark); font-weight: 700; }

.layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 360px);
  gap: clamp(20px, 3vw, 32px);
}

.main { min-width: 0; }
.summary { min-width: 0; }

.summaryCard {
  position: sticky;
  top: 24px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.summaryHead {
  font-family: var(--font-display);
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  margin: 0 0 6px;
  text-transform: uppercase;
}

.summaryList {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.summaryLine {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  font-size: 0.88rem;
  padding: 6px 0;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.06);
}

.summaryName {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.summaryQty { color: var(--color-ink-soft); margin-left: 4px; }

.summaryRow {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding-top: 6px;
  font-size: 1rem;
}

.summaryRow strong { font-size: 1.15rem; }

.summaryNote {
  font-size: 0.78rem;
  color: var(--color-ink-soft);
}

.creditRow {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 8px 10px;
  background: rgba(46, 157, 87, 0.1);
  color: #226c40;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  margin-top: 4px;
}

.creditWarn {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  background: rgba(181, 59, 59, 0.08);
  border: 1px solid rgba(181, 59, 59, 0.4);
  color: #7a2828;
  border-radius: 6px;
  font-size: 0.85rem;
  margin-top: 6px;
}

.creditWarn strong { font-size: 0.92rem; }

.poBadge {
  background: rgba(102, 67, 219, 0.08);
  color: #4928bd;
  border: 1px solid rgba(102, 67, 219, 0.25);
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 0.85rem;
  margin-top: 4px;
}

.stepper {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.step {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px 4px 4px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: var(--color-bone);
  color: var(--color-ink-soft);
}

.stepDot {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.18);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.78rem;
}

.active { background: var(--color-ink); color: #fff; }
.active .stepDot { background: var(--color-ember); color: #111; }
.done { background: rgba(46, 157, 87, 0.14); color: #2e9d57; }
.done .stepDot { background: #2e9d57; color: #fff; }

@container checkout (max-width: 820px) {
  .layout { grid-template-columns: 1fr; gap: clamp(20px, 3vw, 24px); }
  .summaryCard { position: static; }
}
